import { VuexResponse } from '@helpers/vuex-action-builder'

const getDefaultState = () => {
  return {
    releases: [],
    preview: {},
    roadmap: [],
    adaptiveCard: {},
  }
}

const state = getDefaultState()

export default {
  namespaced: true,
  state,

  getters: {
    clientList: (state) => state.clientList,

    getReleaseById: (state) => (releaseId) =>
      state.releases.find((item) => item.releaseId === releaseId),
  },

  mutations: {
    addReleases(state, newReleases) {
      newReleases.forEach((newRelease) => {
        const index = state.releases.findIndex(
          (release) => release.releaseId === newRelease.releaseId
        )

        // If existing release found, update it, else push new release
        index !== -1
          ? state.releases.splice(index, 1, newRelease)
          : state.releases.push(newRelease)
      })

      state.releases.sort(
        (a, b) => new Date(b.dateCreated) - new Date(a.dateCreated)
      )
    },

    SET_STATE(state, { key, value }) {
      state[key] = value
    },
  },
  actions: {
    async init({ dispatch }) {
      try {
        await dispatch('getReleases')
        await dispatch('getRoadmap')
        return true
      } catch (error) {
        return false
      }
    },

    async getReleaseById({ commit }, payload) {
      return await new VuexResponse(commit)
        .request(() => this.$api.releases.getReleaseById(payload))
        .withFailureToast(this.$i18n.t('releases.alerts.failReleaseById'))
        .withCommit(`addReleases`)
        .go()
    },

    async getReleases({ commit }) {
      await new VuexResponse(commit)
        .request(() => this.$api.releases.getReleases())
        .withFailureToast(this.$i18n.t('releases.alerts.failReleases'))
        .withCommit(`addReleases`)
        .go()
    },

    async getPreview({ commit }, payload) {
      await new VuexResponse(commit)
        .request(() => this.$api.releases.getPreview(payload))
        .withFailureToast(this.$i18n.t('releases.alerts.failPreview'))
        .withSetState('preview')
        .go()
    },

    async getRoadmap({ commit }) {
      await new VuexResponse(commit)
        .request(() => this.$api.releases.getRoadmap())
        .withFailureToast(this.$i18n.t('releases.alerts.failRoadmap'))
        .withSetState('roadmap')
        .go()
    },

    async savePreview({ commit, state, dispatch }, payload) {
      await new VuexResponse(commit)
        .request(() => this.$api.releases.savePreview(payload))
        .withFailureToast(this.$i18n.t('releases.alerts.failPreviewSave'))
        .withSuccessToast(this.$i18n.t('releases.alerts.successPreviewSave'))
        .go()

      await dispatch('getReleases')
      const savedPreview = state.releases.find(
        (item) => item.releaseId === payload.releaseId
      )
      // set the newly saved preview as the current preview (so changes persist before posting to teams)
      commit('setState', {
        key: 'preview',
        value: savedPreview,
      })
    },

    // Need to save preview before posting teams message
    async sendTeamsMessage({ commit }, payload) {
      await new VuexResponse(commit)
        .request(() => this.$api.releases.sendTeamsMessage(payload))
        .withFailureToast(this.$i18n.t('releases.alerts.failSendTeamsMessage'))
        .withSuccessToast(
          this.$i18n.t('releases.alerts.successSendTeamsMessage')
        )
        .go()
    },

    async getAdaptiveCard({ commit }, payload) {
      await new VuexResponse(commit)
        .request(() => this.$api.releases.getAdaptiveCard(payload))
        .withFailureToast(this.$i18n.t('releases.alerts.failGetAdaptiveCard'))
        .withSuccessToast(
          this.$i18n.t('releases.alerts.successGetAdaptiveCard')
        )
        .withSetState('adaptiveCard')
        .go()
    },
  },
}
